// extracted by mini-css-extract-plugin
module.exports = {"error":"access-denied_error__PvJ-j","content":"access-denied_content__lCC_n","warning":"access-denied_warning__vVUgJ","text":"access-denied_text__8Eo_j"};